"use client";
import Link from "next/link";

import { useJuneSoEventTracker } from "@stadium/services/june-analytics";
import { useConfig } from "@stadium/hooks/lib/use-config";

import { getBookACallCtaText } from "@stadium/shared/src/selectors/book-a-call";

import { LinkButton } from "@stadium/shared/src/components/shared/button";

import { BYSTADIUM_BOOK_A_CALL } from "@stadium/helpers/app-routes";
import { CHAT_BOT_OPEN, RESOURCES_URL } from "@stadium/shared/src/constants/routes";
import { HEADER_LINKS_SERVICES } from "@stadium/shared/src/constants/june-so";
import { GO_BYSTADIUM_GET_A_QUOTE_ROUTE } from "@stadium/constants/external-routes";

import styles from "./main.module.scss";

export const TalkToSalesInfo = () => {
  const { trackEvent } = useJuneSoEventTracker({ services: HEADER_LINKS_SERVICES });
  const bookACallCtaText = useConfig(getBookACallCtaText);
  return (
    <div className={styles.dropdownFooterRow}>
      <div className={styles.dropdownFooterContent}>
        <Link
          href={BYSTADIUM_BOOK_A_CALL}
          passHref
          className={styles.dropdownFooterContentLink}
          rel="noopener"
          target="_blank"
          onClick={() => trackEvent({ target: "talk-to-sales" })}
        >
          <span className={styles.headphoneIcon} />
          {bookACallCtaText}
          <span className={styles.arrowIcon} />
        </Link>
      </div>
      <div className={styles.dropdownFooterContentRight}>
        <Link
          href={RESOURCES_URL}
          passHref
          className={styles.dropdownFooterContentLink}
          onClick={() => trackEvent({ target: "resources" })}
        >
          LEARNING CENTER
        </Link>
        <span className={styles.dropdownFooterContentSap}>|</span>
        <Link
          href={GO_BYSTADIUM_GET_A_QUOTE_ROUTE}
          passHref
          className={styles.dropdownFooterContentLink}
          onClick={() => trackEvent({ target: "get-a-quote" })}
        >
          GET A QUOTE
        </Link>
      </div>
    </div>
  );
};

export const TalkToServiceInfo = () => {
  const { trackEvent } = useJuneSoEventTracker({ services: HEADER_LINKS_SERVICES });
  return (
    <div className={styles.dropdownFooterRow}>
      <a
        href={CHAT_BOT_OPEN}
        target="_self"
        className={styles.dropdownFooterContentLink}
        onClick={() => trackEvent({ target: "talk-to-customer-service" })}
      >
        <span className={styles.headphoneIcon} />
        TALK TO CUSTOMER SERVICE
      </a>
    </div>
  );
};

export const SpeakWithAnExpertCta = ({ isWeglotDropDown = true, className = "" }) => {
  const bookACallCtaText = useConfig(getBookACallCtaText);
  return (
    <LinkButton
      href={BYSTADIUM_BOOK_A_CALL}
      styleType="primary"
      className={`${
        isWeglotDropDown ? styles.speakExpertCta : styles.marketingSpeakExpertCta
      } ${className}`}
    >
      {bookACallCtaText}
    </LinkButton>
  );
};
